module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Mrs. Adams in Winter")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/halftitle#fig01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Michel François Damame-Demartrais, "), _c('em', [_vm._v("View of the Moika and Palace Bridge")]), _vm._v(" (1812)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter02#fig02"
    }
  }, [_vm._v("Map: Louisa Catherine Adams’s Route, Saint Petersburg to Paris, February 12–March 23, 1815")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/halftitle01#fig03"
    }
  }, [_vm._v("Charles Robert Leslie, "), _c('em', [_vm._v("Louisa Catherine Adams")]), _vm._v(" (1816); engraving by G. F. Storm (ca. 1839)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig04"
    }
  }, [_vm._v("Carriage on Runners")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#fig05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Louisa Catherine Adams, “Narrative of a Journey from Russia to France 1815”")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#fig06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Itinerary from Riga to Saint Petersburg")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#fig07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Berline carriage")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#fig08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kibitka")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#fig09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: Saint Petersburg to Narva")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johann Christoph Brotze, "), _c('em', [_vm._v("Taproom in Inn")]), _vm._v(" (1795)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Narva")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: Narva to Dorpat")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johann Christoph Brotze, "), _c('em', [_vm._v("The Dorpat Stone Bridge")]), _vm._v(" (1800)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: Dorpat to Riga")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: Riga to Memel")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johann Christoph Brotze, "), _c('em', [_vm._v("Peasant Wagons in Estland")]), _vm._v(" (undated)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Memel Lighthouse")]), _vm._v(" (1838)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karl Wilhelm Wach, "), _c('em', [_vm._v("Queen Luise as Hebe in Front of the Brandenburg Gate")]), _vm._v(" (1812)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: Memel to Brandenburg")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: Braunsberg to Graudenz")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: Graudenz to SchÖnlanke")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: SchÖnlanke to Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward Savage, "), _c('em', [_vm._v("Louisa Catherine Johnson")]), _vm._v(" (ca. 1793)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J. D. Laurens and F. C. Dietrich after F. A. Calau, "), _c('em', [_vm._v("Mausoleum of Queen Luise")]), _vm._v(" (1818)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. Malcom, "), _c('em', [_vm._v("Water Color of the Old Adams House, Quincy")]), _vm._v(" (1798)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: Berlin to Leipzig")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: Leipzig to Eisenach")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig28",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Eisenach and Wartburg")]), _vm._v(" (ca. 1700)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#fig29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: Eisenach to Frankfurt")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#fig30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alexander Keith Johnston, "), _c('em', [_vm._v("The Battle of Hanau")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#fig31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johann Jakob de Lose, "), _c('em', [_vm._v("Simon Moritz von Bethmann")]), _vm._v(" (1812)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#fig32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C.J.M. Whichelo, "), _c('em', [_vm._v("South East View of All Hallows Barking")]), _vm._v(" "), _c('em', [_vm._v("(by the Tower)")]), _vm._v(" (1803)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#fig33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Singleton Copley, "), _c('em', [_vm._v("John Quincy Adams")]), _vm._v(" (1796)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#fig34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: Frankfurt to Kehl")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#fig35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: Strasbourg to Châlons-sur-Marne")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#fig36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map: Châlons-sur-Marne to Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#fig37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("George Lewis, "), _c('em', [_vm._v("Beggars Surrounding a Carriage, Epernay")]), _vm._v(" (1823)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#fig38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. de Belport, "), _c('em', [_vm._v("Claude Étienne Michel")]), _vm._v(" (1826)")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#fig39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Port-à-Binson in 1815")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#fig40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Post station, Port-à-Binson")])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#fig41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William James Hubbard, "), _c('em', [_vm._v("Louisa Catherine Adams")]), _vm._v(" (1828)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617a3729","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 72
// module chunks = 0